<template lang="pug">
  v-layout(align-start)
    v-flex
      v-data-table.elevation-1(:headers='headers' item-key='pedidos' :items='pedidos' :search='search' sort-by='Numero' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top)
          v-toolbar(flat color='primary' dark)
            v-toolbar-title Pedidos para Facturar
            v-divider.mx-4(inset vertical)
            v-spacer
            v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
            v-spacer
            v-dialog(v-model='dialog' scrollable persistent max-width='80%')
              v-card(color='grey_1')
                v-app-bar(dark color='primary')
                  v-toolbar-title.headline {{ formTitle }}
                v-divider
                v-card-text
                  v-row(dense)
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-subtitle.title(style='color: black') Orden
                        v-card-text
                          v-row(dense)
                            v-col(cols='12' sm='12' md='4')
                              v-text-field(dense outlined readonly v-model='editedItem.numeroPedido' label='Numero de Pedido')
                            v-col(cols='12' sm='12' md='4')
                              v-text-field( dense outlined readonly v-model='editedItem.idCliente.nombre' label='Cliente')
                            v-col(cols='12' sm='12' md='4')
                              v-text-field( dense outlined readonly v-model='editedItem.fechaRegistro' label='Fecha de registro')
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-subtitle.title(style='color: black') Detalles
                        v-card-text
                          v-row(dense v-if='facturar')
                            v-col(cols='12', xs='12', sm='4' )
                              v-select(dense outlined, v-model='editedItem.tipoVenta', :items='items', label='Tipo de Venta')
                            v-col(cols='12', xs='12', sm='4')
                              v-select(dense outlined, v-model='editedItem.formaPago', :items='formaPago', label='Forma de pago')
                            v-col(v-if='config.campoDiasCreditoCli && config.campoDiasCreditoCli.valor' cols='12' sm='12' md='4')
                              v-dialog(ref='dialog1' v-model='modalven' :return-value.sync='dateVencimiento' readonly persistent width='300px')
                                template(v-slot:activator='{ on }')
                                  v-text-field( v-model='editedItem.fechaVencimiento' label='Fecha de vencimiento' prepend-inner-icon='event' readonly dense outlined v-on='on')
                                v-date-picker( v-model='editedItem.fechaVencimiento' locale="ES" )
                                  v-spacer
                                  v-btn(small dark color='red' @click='modalven = false') Cancelar
                                  v-btn(small dark color='success' @click='$refs.dialog1.save(dateVencimiento)') Ok
                          v-row(dense)
                            v-col(cols='12' sm='12' md='12')
                              v-textarea(auto-grow, v-model='editedItem.observacion', label="Observacion", outlined, dense, v-uppercase)
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          v-row(dense)
                            v-col(cols='12' sm='12' md='12')
                              HijoFacturaPedido(p='activar' :prods='editedItem.detalleProducto' @actualizar="calculos" :facturar='facturar')
                          p
                          v-row(dense class='d-flex justify-end')
                            v-col(v-if='facturar' cols='3' sm='3' md='3')
                              v-text-field(dense readonly outlined :value='editedItem.subTotal | read', label='Subtotal')
                            v-col(v-if='facturar' cols='3' sm='3' md='3')
                              v-text-field(dense readonly :value='editedItem.gravado | read', outlined label='Gravado')
                            v-col(v-if='facturar' cols='3' sm='3' md='3')
                              v-text-field(dense readonly :value='editedItem.exento | read', outlined label='Exento')
                            v-col(v-if='facturar' cols='3' sm='3' md='3')
                              v-text-field(dense readonly :value='editedItem.total | read', outlined label='Total + IVA')
                            v-col(v-else cols='3' sm='3' md='3')
                              v-text-field(dense readonly :value='editedItem.total | read', outlined label='Total')
                v-card-actions
                  v-spacer
                  v-btn(color='error' small dark @click='close')
                    v-icon mdi-close
                    | Cancelar
                  v-btn(color='success' small dark :disabled='boton' @click='save')
                    v-icon mdi-content-save
                    | Facturar
        template(v-slot:item.action='{ item }')
          v-tooltip(bottom)
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='primary_2' @click='editItem(item,false)' v-on="on") mdi-clipboard-text-outline
            | Generar Nota de Entrega
          v-tooltip(bottom)
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='primary_2' @click='editItem(item,true)' v-on="on") mdi-clipboard-check
            | Facturar Pedido
        template(v-slot:no-data)
          h1 No hay pedidos de compras asociadas
      Factura(:dialogFactura='dialogFactura' @close = 'closeF' :origen='origen')
</template>

<script>
import Api from '@/services/methods'
import { server, port } from '../services/environment'
import HijoFacturaPedido from '../components/HijoFacturaPedido'
import { EventBus } from '../Events'
import Factura from '../components/reportes/Factura'

export default {
  name: 'FacturarPedido',
  data: () => ({
    dialogFactura: false,
    config: {
      campoDiasCreditoCli: null
    },
    boton: false,
    origen: '',
    peticion: false,
    overlay: false,
    dialog: false,
    modalven: false,
    dialog1: false,
    dateVencimiento: new Date().toISOString().substr(0, 10),
    facturar: false,
    loading: true,
    headers: [
      { text: 'Numero de Pedido', value: 'numeroPedido', align: 'center' },
      { text: 'Cliente', value: 'idCliente.nombre', align: 'center' },
      { text: 'Fecha de Registro', value: 'fechaRegistro', align: 'center' },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    search: '',
    ruta: server + ':' + port,
    items: ['Credito', 'Al Contado'],
    formaPago: ['Efectivo', 'Tarjeta', 'Transferencia', 'Otro'],
    permisosRuta: {},
    cxc: [],
    pedidos: [],
    vendedores: [],
    diasC: false,
    limiteC: false,
    clientes: [],
    empresa: [],
    nombreUsuario: '',
    editedIndex: -1,
    editedItem: {
      idCliente: [],
      idPedido: [],
      idUsuario: [],
      numeroPedido: '',
      observacion: '',
      detalleProducto: [],
      fechaRegistro: '',
      fechaVencimiento: '',
      subTotal: 0,
      gravado: 0,
      exento: 0,
      baseImponible: 0,
      total: 0,
      debit: 0,
      credito: 0,
      tipoVenta: '',
      formaPago: ''
    },
    defaultItem: {
      idCliente: [],
      idPedido: [],
      idUsuario: [],
      numeroPedido: '',
      observacion: '',
      detalleProducto: [],
      fechaRegistro: '',
      fechaVencimiento: '',
      subTotal: 0,
      gravado: 0,
      exento: 0,
      baseImponible: 0,
      total: 0,
      debit: 0,
      credito: 0,
      tipoVenta: '',
      formaPago: ''
    }
  }),
  components: {
    HijoFacturaPedido,
    Factura
  },
  computed: {
    formTitle () {
      return this.facturar ? 'Facturar Pedido' : 'Nota de Entrega'
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  created () {
    EventBus.$on('hijo', data => { this.calculos() })
    this.initialize()
    this.initialize2()
    this.permisosRuta = this.$store.state.empresa[0].permisos.find(
      permiso => permiso.ruta === 'FacturaPedido'
    )
  },
  methods: {
    initialize () {
      this.config.campoDiasCreditoCli = this.$store.state.config.clientes.campoDiasCreditoCli
      this.listarPedidos()
      this.listarClientes()
      this.listarCuentasXCobrar()
      this.buscarUsuario()
    },

    initialize2 () {
      this.cargarEmpresa(this.$store.state.empresa[0].idEmpresa._id)
    },

    listarPedidos () {
      Api.get('pedido/generados')
        .then(res => {
          this.pedidos = res.data
          this.pedidos.map(data => {
            data.fechaRegistro = this.formato(data.fechaRegistro)
          })
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarClientes () {
      Api.get('cliente')
        .then(res => {
          res.data.map(cliente => {
            this.clientes.push({ text: cliente.nombre, value: cliente._id })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarCuentasXCobrar () {
      Api.get('cuentaporcobrar')
        .then(response => {
          this.cxc = response.data
          let hoy = new Date()
          let moroso
          this.cxc.map((data, i) => {
            if (data.debito === 0) {
              this.cxc[i].estatusPago = 'Cancelada'
            } else {
              this.cxc[i].estatusPago = 'Pendiente'
            }
            data.fechaRegistro = this.formato(data.fechaRegistro)
            if (data.fechaVencimiento) data.fechaVencimiento = this.formato(data.fechaVencimiento)
            if (data.fechaCierreFactura) data.fechaCierreFactura = this.formato(data.fechaCierreFactura)
            let fecha = this.$moment(hoy)
            let fecha2 = this.$moment(data.fechaVencimiento)
            moroso = fecha.diff(fecha2, 'days')
            if (moroso <= 0) this.cxc[i].moroso = 0
            else this.cxc[i].moroso = moroso
          })
        })
        .catch(e => {
          console.log('error' + e)
          this.permissDenied(e.response.status)
        })
    },

    buscarUsuario () {
      Api.get('usuario', this.$store.state.usuario._id)
        .then(res => {
          this.nombreUsuario = res.data[0].nombre
          this.editedItem.idUsuario = this.$store.state.usuario._id
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    cargarEmpresa (id) {
      Api.get(`empresa/${id}`).then(response => {
        this.empresa = response.data
      })
    },

    calculos () {
      this.editedItem.subTotal = 0
      this.editedItem.gravado = 0
      this.editedItem.exento = 0
      this.editedItem.baseImponible = 0
      this.editedItem.total = 0
      if (this.editedItem.detalleProducto.length > 0) {
        for (let i = 0; i < this.editedItem.detalleProducto.length; i++) {
          this.editedItem.subTotal += this.editedItem.detalleProducto[i].subTotal
          this.editedItem.gravado += this.editedItem.detalleProducto[i].gravado
          this.editedItem.exento += this.editedItem.detalleProducto[i].exento
          this.editedItem.baseImponible += this.editedItem.detalleProducto[i].baseImponible
        }
        this.editedItem.total = Math.round( (this.editedItem.subTotal + this.editedItem.gravado) * 100 ) / 100
      }
    },

    formato (fecha) {
      return fecha.substr(0, 10)
    },

    formato2 (fecha) {
      return this.$moment(fecha).format('DD-MM-YYYY')
    },

    validarCrear () {
      return this.permisosRuta?.accion.includes('Crear')
    },
    validarModificar () {
      return this.permisosRuta?.accion.includes('Modificar')
    },
    validarEliminar () {
      return this.permisosRuta?.accion.includes('Eliminar')
    },

    facturarC (cliente) {
      this.cxc.map(data => {
        if (cliente._id === data.idCliente._id) {
          if (cliente.diasCredito < data.moroso) {
            this.diasC = true
          }
        }
      })
    },

    editItem (item, bool) {
      this.facturar = bool
      if (!this.$store.state.config.clientes.campoDiasCreditoCli.valor) this.facturarC(item.idCliente)
      if (!this.diasC) {
        this.editedIndex = this.pedidos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        // no se si tenga problemas de rendimiento poner esos montos en 0
        this.editedItem.detalleProducto.map(prod => {
          if (prod.cantidadActual === 0) {
            this.editedItem.detalleProducto.splice(this.editedItem.detalleProducto.indexOf(prod), 1)
          } else {
            prod.despachada = 0
            prod.porcDescuento = 0
            prod.exento = 0
            prod.baseImponible = 0
            prod.gravado = 0
            prod.subTotal = 0
            prod.total = 0
          } // seguir acomodando imponible
        })
        this.editedItem.subTotal = 0
        this.editedItem.gravado = 0
        this.editedItem.exento = 0
        this.editedItem.baseImponible = 0
        this.editedItem.total = 0
        this.dialog = true
      } else {
        this.$swal({
          icon: 'error',
          title: 'Cliente moroso',
          text: 'El límite de diás de credito ha sido superado'
        })
        this.diasC = false
      }
    },

    deleteItem (item) {
      const index = this.pedidos.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quieres borrar?',
        text: 'No podras revertir esto',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          this.pedidos.splice(index, 1)
          Api.put('/ordenCompra/deletelog/' + item._id).then(response => {
          })
        }
      })
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.editedItem.detalleProducto = []
        this.facturar = false
      }, 300)
    },

    closeF () {
      this.dialogFactura = false
    },

    validarCampos () {
      if (this.editedItem.total === 0) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor debe agregar productos a la factura'
        })
        this.boton = false
        return true
      }

      if (this.facturar) {
        if (!this.editedItem.tipoVenta) {
          this.$swal({
            icon: 'error',
            title: 'Formulario incompleto',
            text: 'Por favor llene todos los campos para continuar'
          })
          this.boton = false
          return true
        }

        if (!this.config.campoDiasCreditoCli.valor) {
          if (!this.editedItem.fechaVencimiento) {
            this.$swal({
              icon: 'error',
              title: 'Formulario incompleto',
              text: 'Por favor llene todos los campos para continuar'
            })
            this.boton = false
            return true
          }
        }

        if (this.editedItem.observacion === '') {
          this.$swal({
            icon: 'error',
            title: 'Formulario incompleto',
            text: 'Por favor debe agregar una observación a la factura'
          })
          this.boton = false
          return true
        }
      }

      if (this.editedItem.total > this.editedItem.idCliente.limiteCredito && !this.$store.state.config.clientes.campoLimCreditoCli.valor) {
        this.$swal({
          icon: 'error',
          title: 'Límite de Credito Excedido',
          text: 'El cliente ha excedido el límite de Credito pemitido, debe facturar por un monto menor'
        })
        this.boton = false
        return true
      }
      return false
    },

    validarCantidades () {
      for (let i = 0; i < this.editedItem.detalleProducto.length; i++) {
        if (this.editedItem.detalleProducto[i].despachada > this.editedItem.detalleProducto[i].stock) {
          this.$swal({
            icon: 'error',
            title: 'Error en las cantidades',
            text: 'Las cantidades a despachar no pueden ser mayor al stock o a la actual'
          })
          this.boton = false
          return true
        }
      }
      return false
    },

    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => { window.location.href = '/home' }
        })
      }
    },

    imprimirFactura (numFactura) {
      const cedula = this.editedItem.idCliente.rif.length === 11 ? this.editedItem.idCliente.rif.substr(2, 8) : this.editedItem.idCliente.rif.substr(2)
      const peticion = {
        cedula: cedula,
        nombre: this.editedItem.idCliente.nombre,
        direcion: this.editedItem.idCliente.direccion,
        numeroFactura: numFactura,
        unidadesVendidas: this.editedItem.detalleProducto.length === 1 ? parseInt(this.editedItem.detalleProducto[0].despachada) : this.editedItem.detalleProducto.reduce((a, b) => parseInt(a.despachada) + parseInt(b.despachada)),
        formaPago: this.editedItem.formaPago,
        condicionPago: this.editedItem.tipoVenta,
        productos: this.editedItem.detalleProducto.filter(producto => parseInt(producto.despachada) > 0).map(producto => {
          return {
            descripcion: producto.idProducto.descripcion,
            codigo: producto.idProducto.nombre,
            cantidad: parseFloat(producto.despachada),
            bsSinIVA: producto.subTotal || null,
            bsConIVA: producto.total || null,
            exento: producto.idIva.valor === 0,
            unidadMedida: producto.idProducto.unidadMedida?.descripcion
          }
        }),
        total: this.editedItem.total
      }

      this.$swal({
        title: 'Imprimiendo...',
        html: 'Esperando respuesta del servidor',
        allowOutsideClick: false,
        onBeforeOpen: () => { this.$swal.showLoading() }
      })

      // ruta para imprimir
      Api.get(`${this.$store.state.ipMaquina}`, peticion)
        .then(res => {
          this.$swal({
            icon: 'success',
            title: 'Impresion exitosa'
          })
          this.exportPDF(this.editedItem)
          this.boton = false
          this.peticion = false
          this.close()
        })
        .catch(err => {
          console.log(err)
          this.$swal({
            icon: 'error',
            title: 'Error al imprimir',
            text: 'Por favor, verifique los datos e intente de nuevo'
          })
          this.exportPDF(this.editedItem)
          this.boton = false
          this.peticion = false
          this.close()
        })
    },

    save () {
      this.boton = true
      if (!this.validarCampos() && !this.validarCantidades() && !this.peticion) {
        this.peticion = true
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => { this.$swal.showLoading() }
        })

        this.overlay = true
        this.editedItem.idPedido = this.editedItem._id
        delete this.editedItem.estatus
        delete this.editedItem._id
        this.editedItem.debito = 0
        this.editedItem.credito = this.editedItem.total

        if (this.facturar) {
          this.origen = 'factura'
          Api.post('venta', this.editedItem)
            .then(res => {
              this.editedItem.numFactura = res.data.numFactura
              this.editedItem.numControl = res.data.numControl
              this.listarPedidos()

              if (this.$store.state.ipMaquina !== '') {
                // inclusion y luego va a imprimir
                this.imprimirFactura(res.data.numFactura)
              } else {
                // inclusion normal
                this.$swal({
                  icon: 'success',
                  title: 'Inclusion exitosa',
                  text: 'Todos los datos han sido guardados'
                })
                let array = {
                  editedItem: this.editedItem,
                  nombreUsuario: this.nombreUsuario,
                  condicion: 'factura',
                  empresa: this.empresa
                }
                // Bus a Factura.vue
                EventBus.$emit('dataFactura', array)
                this.dialogFactura = true
                this.boton = false
                this.peticion = false
                this.close()
                this.initialize2()
              }
            })
            .catch(error => {
              this.boton = false
              this.peticion = false
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al modificar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        } else {
          this.origen = 'nota'
          Api.post('notaEntrega', this.editedItem)
            .then(res => {
              this.editedItem.numFactura = 0
              this.editedItem.numControl = res.data.numNotaEntrega
              this.listarPedidos()
              this.$swal({
                icon: 'success',
                title: 'Inclusion exitosa',
                text: 'Todos los datos han sido guardados'
              })
              let array = {
                editedItem: this.editedItem,
                nombreUsuario: this.nombreUsuario,
                condicion: 'notaEntrega',
                empresa: this.empresa
              }
              // Bus a Factura.vue
              EventBus.$emit('dataFactura', array)
              this.dialogFactura = true
              this.boton = false
              this.peticion = false
              this.close()
              this.initialize2()
            })
            .catch(error => {
              this.boton = false
              this.peticion = false
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al modificar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        }
      }
    }
  }
}
</script>
